import { FC } from 'react';

import HtmlContent from '@telialt/common-html-content/src';
import { useSelectedProductVariant } from '@telialt/core-eshop/src/hooks/useSelectedProductVariant';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { isEmpty } from '@telialt/utils/src/helpers';

import { ChecklistContainer, ChecklistItem, CheckmarkIcon } from './DescriptionChecklist.styles';

const isChecklistEmpty = (descriptions: string[]) => descriptions.every(isEmpty);

export const DescriptionChecklist: FC = () => {
    const productVariant = useSelectedProductVariant();

    const descriptions = [
        productVariant?.shortDescription,
        productVariant?.shortDescription2,
        productVariant?.shortDescription3,
    ];

    if (isChecklistEmpty(descriptions)) {
        return null;
    }

    return (
        <ChecklistContainer data-test={ESHOP_TEST_ID.DESCRIPTION_CHECKLIST}>
            {descriptions.map(
                (description, index) =>
                    description && (
                        <ChecklistItem key={index}>
                            <CheckmarkIcon />
                            <HtmlContent content={description} />
                        </ChecklistItem>
                    ),
            )}
        </ChecklistContainer>
    );
};
